
(function(){
  var selectors=['.dh-hero > *','.dh-section .dh-kicker','.dh-section .dh-title','.dh-card','.dh-method .dh-kicker','.dh-method .dh-title','.dh-method-grid > div','.dh-shilajit-inner > *','.dh-bottom > *','.dhsys-wrap > .dhsys-kicker','.dhsys-wrap > h1','.dhsys-intro','.dhsys-map > div','.dhsys-card','.dhfind-inner > *','.dhprot-inner > *','.dhprot-card','.dhp-top > *','.dhp-panel','.dhp-note','.dhed-inner > *'];
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
  els.forEach(function(el,i){el.setAttribute('data-dh-reveal','');el.style.setProperty('--dh-delay',String(Math.min((i%6)*70,350))+'ms');});
  if(reduce||!('IntersectionObserver' in window)){els.forEach(function(el){el.setAttribute('data-dh-visible','true');});return;}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.setAttribute('data-dh-visible','true');io.unobserve(entry.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  els.forEach(function(el){io.observe(el);});
  var resin=document.querySelector('.dh-resin');
  if(resin&&window.matchMedia('(pointer:fine)').matches){
    var raf=0;
    window.addEventListener('pointermove',function(e){
      if(raf)return;
      raf=requestAnimationFrame(function(){
        var x=e.clientX/window.innerWidth-.5;
        var y=e.clientY/window.innerHeight-.5;
        resin.style.boxShadow='inset -45px -35px 100px rgba(0,0,0,.78), inset '+(18-x*10)+'px '+(18-y*10)+'px 45px rgba(255,196,125,.10), '+(x*8)+'px '+(50+y*10)+'px 120px rgba(0,0,0,.52)';
        raf=0;
      });
    },{passive:true});
  }
})();
